import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { Icon, SportsLink } from '@swf/sports/components';
import { useEventMarketTemplatesWidget } from '@swf/sports/models/market-templates/eventBased';
import type { EventTypeId } from '@swf/sports/types/eventType';
import type {
  MarketTemplateComponent,
  SingleMarketTemplateProps
} from '@swf/sports/types/templates';
import { getEventTypeIcon } from '@swf/sports/utils/getEventTypeIcon';

import styles from './Link.scss';

const LinkTemplate: MarketTemplateComponent<SingleMarketTemplateProps> = ({ marketId }) => {
  const { widgetSelect } = useEventMarketTemplatesWidget();
  const market = useSelector((state: RootState) => widgetSelect.market(state, marketId));
  const event = useSelector((state: RootState) => widgetSelect.event(state, market?.eventId ?? -1));
  const eventType = useSelector((state: RootState) =>
    widgetSelect.eventType(
      state,
      (market?.eventTypeId as EventTypeId | undefined) ?? (-1 as EventTypeId)
    )
  );

  if (!market) return null;

  const icon = getEventTypeIcon(market.eventTypeId);

  return (
    <SportsLink
      className={styles.linkWrapper}
      alias="sportsAnimalRacingFutureMarket"
      values={{
        marketId: market.marketId,
        eventTypeSlug: eventType.eventTypeSlug,
        eventTypeId: market.eventTypeId,
        eventSlug: event.eventSlug
      }}
    >
      <div className={styles.linkInner}>
        <Icon size="x2" name={icon} />
        <span className={styles.linkText}>{market.marketName}</span>
        <Icon name="chevron-medium-right" className={styles.linkIcon} size="lg" />
      </div>
    </SportsLink>
  );
};

LinkTemplate.marketTemplateType = 'BASE';

export default LinkTemplate;
